<template>
  <div class="department-business-list">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchConfig"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'accountingStatus'">{{
              transferSelectLabel(scope.row[item.field], laccountingStatusOptions)
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import { mapState } from 'vuex';
  import AGENCY_API from '@/api/agencyContract/index';
  import COMPANY_API from '@/api/masterData/company';
  import API from '@/api/departmentBusiness/index';
  import { filterEmpty } from '@/common/js/util';
  import SALES_API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  export default {
    mixins: [tableMixins],
    name: 'departmentBusinessList',
    components: {
      SiruiSearch,
      SiruiTable,
      BatchConfirmDialog,
    },
    data() {
      return {
        load: false,
        tableData: [],
        multipleSelection: [],
        query: {
          tradeNo: '',
          tradeStatus: '',
          saleDepartmentCode: '',
          buyDepartmentCode: '',
          productNo: '',
          supplierNo: '',
          tradeType: '',
          vochurePostDateStart: '',
          vochurePostDateEnd: '',
          tradeCreatePersonNo: '',
          tradeCreateDate: '',
          tradeCreateDateStart: '',
          tradeCreateDateEnd: '',
        },
        menuButtonList: [], // 表格功能按钮
        laccountingStatusOptions: [],
        columnListDefault: [
          {
            type: 'checkbox',
            width: '50',
            fixed: 'left',
            visible: true,
          },
          {
            field: 'tradeNo',
            title: 'departmentBusiness.departmentBusinessId',
            width: 120,
            fixed: 'left',
            visible: true,
          },
          { field: 'tradeStatusName', title: 'departmentBusiness.status', visible: true },
          { field: 'tradeTypeName', title: 'departmentBusiness.businessType', visible: true },
          {
            field: 'saleDepartmentName',
            title: 'departmentBusiness.sellDepartment',
            visible: true,
          },
          { field: 'buyDepartmentName', title: 'departmentBusiness.buyDepartment', visible: true },
          { field: 'productDesc', title: 'departmentBusiness.productName', visible: true },
          { field: 'supplierName', title: 'departmentBusiness.supplierName', visible: true },
          { field: 'tradeQuantity', title: 'departmentBusiness.businessNumber', visible: true },
          {
            field: 'businessTradePrice',
            title: 'departmentBusiness.businessPrice',
            width: 120,
            visible: true,
          },
          {
            field: 'businessTradeAmount',
            title: 'departmentBusiness.businessPrice1',
            width: 120,
            visible: true,
          },
          { field: 'vochurePostDate', title: 'departmentBusiness.postTime', visible: true },
          { field: 'tradeCreateDate', title: 'departmentBusiness.orderMakeTime', visible: true },
          {
            field: 'tradeCreatePersonName',
            title: 'departmentBusiness.orderMakeName',
            visible: true,
          },
          {
            field: 'accountingStatus',
            title: 'departmentBusiness.accountingStatus',
            visible: true,
          },
        ],
        columnList: [],
      };
    },
    computed: {
      // 搜索栏展示字段
      searchConfig() {
        const userInfo = this.userInfo;
        const companyCode = userInfo.companyCode;
        const departmentUrl = `${COMPANY_API.GET_COMPANY_DETAIL_API}/${companyCode}`;
        return [
          {
            name: this.$t('departmentBusiness.departmentBusinessId'),
            prop: 'tradeNo',
            type: 'input',
          },
          {
            name: this.$t('departmentBusiness.status'),
            prop: 'tradeStatus',
            type: 'ajaxSelect',
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'department_business_status' },
            clearable: true,
          },
          {
            // 卖出部门搜索
            type: 'ajaxSelect',
            name: this.$t('departmentBusiness.sellDepartment'),
            prop: 'saleDepartmentCode',
            apiUrl: departmentUrl,
            clearable: true,
            apiData: {},
            method: 'get',
            dataString: 'data.department',
            valueKey: 'createDepartmentCode',
            labelKey: 'createDepartmentName',
          },
          {
            // 买入部门搜索
            type: 'ajaxSelect',
            name: this.$t('departmentBusiness.buyDepartment'),
            prop: 'buyDepartmentCode',
            apiUrl: departmentUrl,
            clearable: true,
            apiData: {},
            method: 'get',
            dataString: 'data.department',
            valueKey: 'createDepartmentCode',
            labelKey: 'createDepartmentName',
          },
          {
            type: 'searchTableSpec',
            name: this.$t('contractAgency.productDesc'),
            prop: 'productNo',
            searchType: 'goodsDetail',
            isMultiple: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('departmentBusiness.supplierName'),
            prop: 'supplierNo',
            searchType: 'supplier',
            extraData: {
              departmentCode: this.query.saleDepartmentCode,
              companyCode: this.userInfo.companyCode,
            },
            isMultiple: true,
          },
          {
            name: this.$t('departmentBusiness.businessType'),
            prop: 'tradeType',
            type: 'ajaxSelect',
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'department_trade_type' },
            clearable: true,
          },
          {
            type: 'searchTableSpec',
            name: this.$t('departmentBusiness.orderMakeName'),
            prop: 'tradeCreatePersonNo',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            name: this.$t('departmentBusiness.vochurePostDateStart'),
            prop: 'vochurePostDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('departmentBusiness.vochurePostDateEnd'),
            prop: 'vochurePostDateEnd',
            type: 'endDaterangePicker',
          },
          {
            name: this.$t('departmentBusiness.tradeCreateDateStart'),
            prop: 'tradeCreateDateStart',
            type: 'startDaterangePicker',
          },
          {
            name: this.$t('departmentBusiness.tradeCreateDateEnd'),
            prop: 'tradeCreateDateEnd',
            type: 'endDaterangePicker',
          },

          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
        this.getDictList();
      });
    },
    methods: {
      // 处理跳转：编辑、详情、新增
      handlePath(type, tradeNo) {
        let path, name, title;
        if (type == 'add') {
          path = '/departmentBusiness/add';
          name = 'departmentBusinessAdd';
          title = this.$t('departmentBusiness.addButton');
        }
        if (type == 'edit') {
          path = '/departmentBusiness/edit';
          name = 'departmentBusinessEdit';
          title = this.$t('departmentBusiness.editTitle');
        }
        let pathRoute = {
          path: path,
          name: name,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: tradeNo ? { tradeNo } : {},
        };
        this.$store.dispatch('tagsView/addTabView', pathRoute).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathRoute);
          });
        });
      },
      //下拉中文转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // 点击按钮
      chooseClick(type) {
        if (type == 'add') {
          this.handlePath('add');
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(API.BATCH_SIGN_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type === 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_PO_CST_ADJUSTMENT',
            { idList: this.multipleSelection.map((it) => it.id) },
            'idList'
          );
        }
      },
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        //入账状态 notgenerate-未生成,generated-已生成未入账,posted-已入账,postError-入账失败
        this.$axios
          .post(SALES_API.DICT_LIST, { dictType: 'post_status', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.laccountingStatusOptions = res.data.data;
              console.log(this.laccountingStatusOptions);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      getData() {
        const params = this.getQuery();
        /*   if (search && Object.keys(params).length == 2) {
        this.$message({
          showClose: true,
          message: this.$t('search.nosearchError'),
          type: "error" });
        return;
      } */
        this.load = true;
        // 获取数据
        this.$axios
          .post(API.LIST_TRADE, params)
          .then((res) => {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data.list;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      // 获取查询参数
      getQuery() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        // 时间、制单人数据
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          // productNo: query.productNo && query.productNo[0] ? query.productNo[0].productDetailCode : '',
          supplierNo:
            query.supplierNo && query.supplierNo[0]
              ? query.supplierNo[0].allPartnerCode
                ? query.supplierNo[0].allPartnerCode
                : query.supplierNo[0].partnerCode
              : '',
          productNo:
            query.productNo && query.productNo[0]
              ? query.productNo[0].allProductDetailCode
                ? query.productNo[0].allProductDetailCode
                : query.productNo[0].productDetailCode
              : '',
          tradeCreatePersonNo:
            query.tradeCreatePersonNo && query.tradeCreatePersonNo[0]
              ? query.tradeCreatePersonNo[0].id
              : '',
        });
        return filterEmpty(result);
      },
      // 列表双击：查看详情
      dblclickEvent(value) {
        const row = value.row;
        this.handlePath('edit', row.tradeNo);
      },
    },
  };
</script>
